import React from 'react';

interface CheckboxIconProps {
  isSelected: boolean;
}

const CheckboxIcon: React.FC<CheckboxIconProps> = ({ isSelected }) => {
  const renderIcon = (
    fillColor: string,
    strokeColor: string,
    strokeWidth: number
  ) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      className="custom-checkbox-icon"
    >
      <g filter={`url(#filter0_${isSelected ? 'selected' : 'unselected'})`}>
        <rect
          x="0.5"
          y="0.5"
          width="19"
          height="19"
          rx="2.5"
          stroke={strokeColor}
        />
        <g filter={`url(#filter1_${isSelected ? 'selected' : 'unselected'})`}>
          <rect
            x="1"
            y="1"
            width="18"
            height="18"
            rx="3"
            fill={fillColor}
          />
        </g>
        <rect
          x="2"
          y="2"
          width="16"
          height="16"
          rx="2"
          stroke={strokeColor}
          strokeWidth={strokeWidth}
        />
      </g>
      <defs>
        <filter
          id="filter0_selected"
          x="-1"
          y="-3"
          width="21"
          height="23"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feOffset dx="-1" dy="-3" />
          <feGaussianBlur stdDeviation="3.5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.454545 0 0 0 0 0.544866 0 0 0 0 0.617122 0 0 0 0.3 0"
          />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_selected" />
        </filter>
        <filter
          id="filter0_unselected"
          x="-1"
          y="-3"
          width="21"
          height="23"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feOffset dx="-1" dy="-3" />
          <feGaussianBlur stdDeviation="3.5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.454545 0 0 0 0 0.544866 0 0 0 0 0.617122 0 0 0 0.3 0"
          />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_unselected" />
        </filter>
        <filter
          id="filter1_selected"
          x="0"
          y="-2"
          width="20"
          height="22"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feOffset dx="-1" dy="-3" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.454545 0 0 0 0 0.544866 0 0 0 0 0.617122 0 0 0 0.35 0"
          />
          <feBlend mode="normal" in2="shape" result="effect_selected" />
        </filter>
        <filter
          id="filter1_unselected"
          x="0"
          y="-2"
          width="20"
          height="22"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feOffset dx="-1" dy="-3" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.454545 0 0 0 0 0.544866 0 0 0 0 0.617122 0 0 0 0.35 0"
          />
          <feBlend mode="normal" in2="shape" result="effect_unselected" />
        </filter>
      </defs>
    </svg>
  );

  return isSelected
    ? renderIcon('#26A3E3', '#26A3E3', 2)
    : renderIcon('white', '#DBE8F4', 1);
};

export default CheckboxIcon;